import get from 'lodash.get';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { format } from 'date-fns';

import {
    VirtualizedTableItem,
    VirtualizedTableColumns
} from 'services/virtualizedTable/types';

import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import {
    FIELD_TYPE_STRING,
    FIELD_TYPE_DATE,
    FIELD_TYPE_STATUS_ICON
} from 'components/VirtualizedTable/constants';
import { SpraySubmission } from 'services/spraySubmissions/types';
import { selectFormattedSpraySubmissions } from 'services/spraySubmissions/selectors';
import { selectIsAdmin, selectIsManager } from 'services/usersMe/selectors';

const selectSubmissionsTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths()],
    (tableColumnWidths): VirtualizedTableColumns<SpraySubmission> => {
        const result: VirtualizedTableColumns<SpraySubmission> = [
            {
                label: 'Submitted at',
                value: 'createdAt',
                width: 175,
                type: FIELD_TYPE_DATE,
                disableUpdating: true
            },
            {
                label: 'Submitted by',
                value: 'createdBy',
                width: 250,
                type: FIELD_TYPE_STRING,
                disableUpdating: true
            },
            {
                label: 'Status',
                value: 'status',
                width: 100,
                type: FIELD_TYPE_STATUS_ICON,
                disableUpdating: true
            }
        ];

        return result.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

const selectFilteredSubmissionItems = createDeepEqualSelector(
    selectFirstDate,
    selectLastDate,
    selectFormattedSpraySubmissions,
    (firstDate: string, lastDate: string, spraySubmissions) =>
        spraySubmissions.filter((submission) => {
            const createdAt = format(
                new Date(submission.createdAt),
                'yyyy-MM-dd'
            );

            return createdAt >= firstDate && createdAt <= lastDate;
        })
);

const selectSubmissionItems = createDeepEqualSelector(
    selectFilteredSubmissionItems,
    (spraySubmissions) =>
        spraySubmissions.map(
            (spraySubmission: SpraySubmission): VirtualizedTableItem => {
                return {
                    ...spraySubmission,
                    key: spraySubmission.id
                };
            }
        )
);

const selectIsWritable = createDeepEqualSelector(
    selectIsAdmin,
    selectIsManager,
    (isAdmin: boolean, isManager: boolean) => isAdmin || isManager
);

const makeSelectSubmissionItems = (): typeof selectSubmissionItems =>
    selectSubmissionItems;

export {
    selectSubmissionsTableColumns,
    selectSubmissionItems,
    selectIsWritable,
    makeSelectSubmissionItems
};
